if ($('.main-page').length) {
	$(window).on('scroll', (e) => {
		let $this = $(e.currentTarget);

		let pos = $this.scrollTop();

		let headerHeight = $('.header').outerHeight() + 10;

		let faqBottomPos = $(window).height() - $('.faq .container-inner').height();

		faqBottomPos = $('.faq .container-inner').offset().top - faqBottomPos;

		if (pos > 500) {
			$('.header').addClass('is-fixed');
			$('.button-up').show();
		} else {
			$('.header').removeClass('is-fixed');
			$('.button-up').hide();
		}

		if ($('.main-page').length && innerWidth > 1025) {
			$('.section-scroll').each((i, element) => {
				if ($(element).position().top < pos + headerHeight) {
					$('.menu__link.is-active').removeClass('is-active');
					$('.menu__link').eq(i).addClass('is-active');
				}
			});
		}

		if (pos > faqBottomPos) {
			$('.button-up').addClass('is-bottom-fixed');
		} else {
			$('.button-up').removeClass('is-bottom-fixed');
		}
	});
}

$('.menu__burger').on('click', (e) => {
	e.preventDefault();

	if (!$('.header').hasClass('is-active')) {
		$('.header').addClass('is-active');
		$('.mobile-panel').show();
		$('body').addClass('is-menu-open');
	} else {
		$('.header').removeClass('is-active');
		$('.mobile-panel').hide();
		$('body').removeClass('is-menu-open');
	}
});

$('.button-up').on('click', (e) => {
	e.preventDefault();

	$('html, body').animate({scrollTop: 0}, 750);
});

$('.mobile-panel__lang').on('click', (e) => {
	e.preventDefault();

	let $this = $(e.currentTarget);

	if ($this.next().is(':hidden')) {
		$this.next().show();
	} else {
		$this.next().hide();
	}
});
